<template>
  <!--детальный вид заказа в истории заказов в модалке-->
  <div class="tm-order tm-order-check tm-senior-retoucher-order-view">
    <preloader :is-visible="isLoading"/>
    <div class="uk-grid uk-grid-small tm-senior-retoucher" data-uk-grid>
      <!--левая часть-->
      <div class="uk-width-expand">
        <ProRetouchersMainPhotoBlock
          v-if="creteMainPhotoBlock"
          :main_photo_block="main_photo_block"
          :with-faces-visible="withFacesVisible"
          :zone-visible="zoneVisible"
          :order_number="order_number"
          :zone_photo="zone_photo"
          :fullImageList="fullImageList"
          :afterVisible="afterVisible"
          :isOutChat="isOutChat"
          @is-loading="isLoading = $event"/>
      </div>
      <!--правая часть-->
      <div class="uk-width-1-4 1">
        <order-card-head :order_number="order_number"
                         :main_photo_before_with_faces="main_photo_before_with_faces"
                         :role="user.role"
                         @visible="withFacesVisible = $event"
                         @visible-after="afterVisible = $event"></order-card-head>
        <ProRetouchersInfoBlock
          v-if="createInfoBlock"
          :order_id="order_id"
          :main_photo_before_with_faces="main_photo_before_with_faces"
          :how_much_orders="how_much_orders"
          :archive="archive"
          @zone-visible="zoneVisible = $event"
          @after-visible="afterVisible = $event"
          @zone_photo="zone_photo = $event"
          @loading="infoloading = $event"
          @order_cost_credits="cost = $event"
          @faces="faces = $event"
          @with-faces-visible="withFacesVisible = $event"
          permission="read"/>
        <div @mouseleave="isOutChat = true" @mousemove="isOutChat = false">
          <ChatBlock
            :infoloading="infoloading"
            v-if="order_chat !== '' && user"
            :order_chat="order_chat"
            :faces="faces"
            :order_id="Number (order_id)"
            :user="user.email"
            :role="user.role"
            @zone-visible="zoneVisible = $event"
            @after-visible="afterVisible = $event"
            @zone_photo="zone_photo = $event"
            @loading="infoloading = $event"/>
        </div>
        <CommentForRatingProRetoucher
        v-if="order_chat !== '' && this.user.role === 'pro-retoucher'"
        :local_page_keys="local_page_keys"
        :order_id="Number (order_id)"
        :order_chat="order_chat"
        :order_senior_retoucher_quality="order_senior_retoucher_quality"
        :infoloading="infoloading"
        :education_pro_retoucher="education_pro_retoucher"
        @reloadChat="reLoadChat"/>
        <ActivitiesOfSeniorRetoucher
        v-if="createButtonsBlock"
        :local_page_keys="local_page_keys"
        :loading="infoloading"
        :faces="makeFacesAsArrayOfObjects(faces)"
        :order_id="order_id"
        :main_photo_after="main_photo_after"
        :main_photo_before="main_photo_before"
        :role="this.user.role"
        :canvasWidth="canvasWidth"
        :canvasHeight="canvasHeight"
        :prev_status_order="prev_status_order"
        :order_number="order_number"
        :cost="cost"
        :getNewOrder=false
        :order_chat="order_chat"
        :orderWeekComment="orderWeekComment"
        @reload="reLoadPage"
        @is-loading="isLoading = $event"
        ref="activitiesOfSeniorRetoucher"/>
      </div>
    </div>
  </div>
</template>

<script>
import Preloader from "@/pages/Dashboard/Components/Preloader";
import OrderCardHead from "@/pages/Dashboard/Components/OrderCardHead";
import ProRetouchersMainPhotoBlock from "@/pages/Dashboard/Components/for_pro_retouchers/ProRetouchersMainPhotoBlock";
import ProRetouchersInfoBlock from "@/pages/Dashboard/Components/for_pro_retouchers/ProRetouchersInfoBlock";
import CommentForRatingProRetoucher from "@/pages/Dashboard/Components/for_pro_retouchers/CommentForRatingProRetoucher";
import ChatBlock from "@/pages/Dashboard/Components/ChatBlock";
import ActivitiesOfSeniorRetoucher from "@/pages/Dashboard/Components/for_senjor_retouchers/ActivitiesOfSeniorRetoucher";

export default {
  name: 'ViewOrder',
  props: {
    orderWeekComment: Number,
    archive: {
      type: Boolean,
      default:false
    },
  },
  data: () => ({
    infoloading: true,
    creteMainPhotoBlock: false,
    createInfoBlock: false,
    main_photo_block: null,
    main_photo_before_with_faces: null,
    afterVisible: true,
    withFacesVisible: false,
    zoneVisible: false,
    zone_photo: null,
    isLoading: true,
    order_number: '',
    order_id: '',
    faces: [],
    local_page_keys: {},
    order_chat: '',
    my_email: '',
    cost: 0,
    main_photo_after: null,
    main_photo_before: null,
    canvasWidth: 560,
    canvasHeight: 360,
    prev_status_order: null,
    //role: '',
    errors: null,
    user: '',
    createButtonsBlock: false,
    order_status:null,
    order_senior_retoucher_quality:'',
    getterKey:0,
    education_pro_retoucher:false,
    fullImageList: {},
    isOutChat: true
  }),
  components: {
    Preloader,
    ChatBlock,
    OrderCardHead,
    ProRetouchersMainPhotoBlock,
    ProRetouchersInfoBlock,
    ActivitiesOfSeniorRetoucher,
    CommentForRatingProRetoucher
  },
  methods: {
    async fetchMainPhotoBlock() {
      try {
        let data = null;
        if (!this.order_id) {
          await this.$store.dispatch("order/getViewOrder");
        } else {
          await this.$store.dispatch("order/getViewOrder", { order_id:this.order_id, archive:this.archive});
        }

        data = await this.$store.getters['order/viewOrder'];
        if (data) {
          if (typeof (data) !== 'string') {
            this.order_id = data.order_id;
            this.main_photo_before_with_faces =  !this.isURL(data.main_photo_before_with_faces) ? process.env.VUE_APP_API_BASE_URL.replace('api/v1', '') + data.main_photo_before_with_faces: data.main_photo_before_with_faces;
            this.order_number = data.order_number;
            this.order_status = data.status;
            this.order_senior_retoucher_quality = data.senior_retoucher_quality;
            await this.fetchChatBlock();
            this.main_photo_block = data;
            this.creteMainPhotoBlock = true;
            this.createInfoBlock = true;
            this.isLoading = false;
            this.prev_status_order = data.prev_status_order;
            this.how_much_orders = data.how_much_orders
            if (Object.keys(data).includes('main_photo_after')) {
              this.main_photo_after = data.main_photo_after;

              this.canvasWidth = data.main_photo_after_width !== '' ? data.main_photo_after_width : this.canvasWidth;
              this.canvasHeight = data.main_photo_after_height !== '' ? data.main_photo_after_height : this.canvasHeight;

             // this.main_photo_before = process.env.VUE_APP_API_BASE_URL.replace('api/v1', '') + data.main_photo_before;
              this.main_photo_before =  data.main_photo_before;
            } else {
              this.main_photo_before = data.main_photo_before;
              this.canvasWidth = data.main_photo_before_width !== '' ? data.main_photo_before_width : this.canvasWidth;
              this.canvasHeight = data.main_photo_before_height !== '' ? data.main_photo_before_height : this.canvasHeight;
            }
            if (Object.keys(data).includes('order_url_signature')) {
              this.$emit('orderInfo', {
                order_number: data.order_number,
                order_url_signature: data.order_url_signature,
                order_api_url_signed: data.order_api_url_signed,
              });
            }
            this.fullImageList = data.order_photo_file_list;

          } else {
            this.isLoading = false;
          }
        } else {
          this.errors = this.local_page_keys.alert_failed_main_photo_block;
        }
      } catch (e) {
        alert(e);
      }
    },
    async fetchChatBlock() {
      try {
        let data;
        await this.$store.dispatch("order/historyBlock", { order_id:this.order_id, archive:this.archive});
        data = await this.$store.getters["order/historyBlock"];
        if (data.status === 'ok') {
          this.order_chat = data.chat !== '' ? JSON.parse(data.chat) : '';
        } else {
          this.errors = this.local_page_keys.alert_failed_historyBlock;
          this.loading = false;
        }
      } catch (e) {
        alert(e);
      }
    },
    async reLoadPage() {
      this.order_chat = '';
      await this.fetchChatBlock();
      this.createButtonsBlock = false;
      this.$refs.activitiesOfSeniorRetoucher.closeDialog()
    },
    async reLoadChat(){
      this.order_chat = '';
      await this.fetchChatBlock();
    },
    makeFacesAsArrayOfObjects(faces, updateThisFaces = false){

      let facesArr = [];

      if(!Array.isArray(faces)){
        if(0 in faces) facesArr.push({});
        Object.keys(faces).forEach(function(key){
          if(typeof Number(key) == 'number') facesArr[Number(key)] = faces[key];
        })
        return facesArr;
      }
      return faces;
    },
    lastMessageRole() {
      const lastItem = this.order_chat[this.order_chat.length - 1];
      return  lastItem.role;
    },
    isURL(str) {
      if(!str)
        return false;

      return str.startsWith('http://') || str.startsWith('https://');
    }
  },
  async created() {
    this.local_page_keys = Object.assign({}, await this.$filtergetLocalisationPage('order-orderCheck'), await this.$filtergetLocalisationPage('pro_retoucher_progress_report'));
    //this.role = await this.$store.getters['profile/role'];
    this.order_id = await this.$store.getters['order/viewOrderId'];
    await this.$store.dispatch('profile/me');
    this.getterKey++;
    this.user = await this.$store.getters['profile/me'](this.getterKey);
    if(typeof this.user == 'object' && 'education_pro_retoucher' in this.user && this.user.education_pro_retoucher === true) this.education_pro_retoucher = this.user.education_pro_retoucher;
    await this.fetchMainPhotoBlock();
    this.createButtonsBlock = (this.user.role === 'senior-retoucher' && (this.order_status === 'done-admin' || this.order_status === 'rejected-admin' ) && this.lastMessageRole() !== 'senior-retoucher');
   //this.createButtonsBlock = this.user.role === 'senior-retoucher';
  },
}
</script>
<style>
/*Layout*/
@import '../../../assets/css/uikit/grid.css';
/*Utilities*/
@import '../../../assets/css/uikit/background.css';
@import '../../../assets/css/uikit/label.css';
@import '../../../assets/css/uikit/width.css';
@import '../../../assets/css/uikit/height.css';
@import '../../../assets/css/uikit/flex.css';
@import '../../../assets/css/uikit/margin.css';
@import '../../../assets/css/uikit/padding.css';
@import '../../../assets/css/uikit/position.css';
@import '../../../assets/css/uikit/utility.css';
@import '../../../assets/css/uikit/transition.css';
@import '../../../assets/css/uikit/text.css';
@import '../../../assets/css/uikit/overlay.css';
@import '../../../assets/css/uikit/animation.css';
@import '../../../assets/css/custom.css';

.tm-file-name {
  word-break: break-all;
  line-height: 1;
}

.prev-img {
  width: 60px;
  height: 60px;
  background-color: #ccc
}

#files-area {
  border-radius: 6px;
  border: 3px dashed #e8e8e8;
  background-color: #f5f5f5;
  min-height: 100px;
}

.file-block {
  overflow: hidden;
  border-radius: 6px;
  background-color: rgba(144, 163, 203, 0.2);
  margin: 5px 0;
}

.tm-file-delete {
  cursor: pointer;
  padding: 10px;
}

/*.tm-button-add {*/
/*  padding: 0px 9px;*/
/*  border-radius: 50px;*/
/*}*/

.main-photo-dialog {
  height: 100%;
}

.left-part-main-photo {
  width: 100%;
}

.buttons {
  display: flex;
  flex-direction: row;
  width: 100%;
}

.comments-button {
  border: #297a96 2px solid;
  border-radius: 5px;
  width: 75%;
  height: 90%;
  background: none;
  color: #3e3d3d;
  margin: 2px;
}

.scrollable-dialog {
  max-height: 80% !important;
  overflow-y: auto;
}

.checkFunctions {
  display: contents;
}

.image-compare-handle {
  color: #f10404;
  background-color: currentColor;
  cursor: ew-resize;
  transform: translateX(-50%) translateZ(0);
  width: 2px;
  z-index: 2;
  will-change: left;

}

/*.tm-block-img {*/
/*  background-color: #f0f0f0;*/
/*  width: 550px;*/
/*  height: 550px;*/
/*  display: -webkit-box;*/
/*  display: -ms-flexbox;*/
/*  display: flex;*/
/*  -webkit-box-align: center;*/
/*  -ms-flex-align: center;*/
/*  align-items: center;*/
/*  -webkit-box-pack: center;*/
/*  -ms-flex-pack: center;*/
/*  justify-content: center;*/
/*}*/

/*.tm-order-check .tm-block-img img {*/
/*  height: 100%;*/
/*  object-fit: contain;*/
/*}*/

/*.main-photo-image {*/
/*  min-width: 550px;*/
/*}*/

.display {
  display: none;
}

.cancel-order {
  margin: auto;
}

</style>